import { useTranslation } from 'react-i18next';

function OrganisationBrandingAndStylingPage() {
  const { t } = useTranslation();
  return <h1>{t('pages.organisation_branding_and_styling.title')}</h1>;
}

export default OrganisationBrandingAndStylingPage;
